import * as Mod1 from "./api-initializers/inline-footnotes";
import * as Mod2 from "./discourse/initializers/footnote-admin-plugin-configuration-nav";
import * as Mod3 from "./initializers/composer";
import * as Mod4 from "./lib/discourse-markdown/footnotes";
import * as Mod5 from "./lib/rich-editor-extension";
const compatModules = {
  "api-initializers/inline-footnotes": Mod1,
  "discourse/initializers/footnote-admin-plugin-configuration-nav": Mod2,
  "initializers/composer": Mod3,
  "lib/discourse-markdown/footnotes": Mod4,
  "lib/rich-editor-extension": Mod5,
};
export { compatModules };
export default compatModules;
